/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listing_PersonalityInputs */

const en_listing_personality = /** @type {(inputs: Listing_PersonalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing Personality`)
};

const es_listing_personality = /** @type {(inputs: Listing_PersonalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personalidad del anuncio`)
};

const fr_listing_personality = /** @type {(inputs: Listing_PersonalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personnalité de l'annonce`)
};

const de_listing_personality = /** @type {(inputs: Listing_PersonalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserat-Persönlichkeit`)
};

const ja_listing_personality = /** @type {(inputs: Listing_PersonalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出品のペルソナ (AI設定)`)
};

const zh_listing_personality = /** @type {(inputs: Listing_PersonalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`商品 AI 个性设定`)
};

const ar_listing_personality = /** @type {(inputs: Listing_PersonalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شخصية الإعلان بالذكاء الاصطناعي`)
};

const id_listing_personality = /** @type {(inputs: Listing_PersonalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kepribadian Listing`)
};

const it_listing_personality = /** @type {(inputs: Listing_PersonalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personalità dell'Annuncio`)
};

const ru_listing_personality = /** @type {(inputs: Listing_PersonalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Индивидуальность объявления (ИИ)`)
};

const pt_listing_personality = /** @type {(inputs: Listing_PersonalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personalidade do Anúncio`)
};

const ko_listing_personality = /** @type {(inputs: Listing_PersonalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 페르소나 (상품 대응)`)
};

/**
* | output |
* | --- |
* | "Listing Personality" |
*
* @param {Listing_PersonalityInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const listing_personality = /** @type {((inputs?: Listing_PersonalityInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listing_PersonalityInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listing_personality(inputs)
	if (locale === "es") return es_listing_personality(inputs)
	if (locale === "fr") return fr_listing_personality(inputs)
	if (locale === "de") return de_listing_personality(inputs)
	if (locale === "ja") return ja_listing_personality(inputs)
	if (locale === "zh") return zh_listing_personality(inputs)
	if (locale === "ar") return ar_listing_personality(inputs)
	if (locale === "id") return id_listing_personality(inputs)
	if (locale === "it") return it_listing_personality(inputs)
	if (locale === "ru") return ru_listing_personality(inputs)
	if (locale === "pt") return pt_listing_personality(inputs)
	return ko_listing_personality(inputs)
});